<template>
  <div class="grid grid-cols-1 gap-4">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
          for="reportDocuments"
        >
          Report Documents
        </label>
        <div class="upload-image">
          <input
            id="reportDocuments"
            ref="uploadInput"
            type="file"
            class="file-uploader !h-10 p-0"
            @change="uploadImage"
          >
          <div
            class="ml-4"
            :class="
              ` ${
                fileLoader
                  ? 'is-loading button primary'
                  : 'button primary'
              } `
            "
            @click="handleAddClickManual()"
          >
            Check
          </div>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
          for="letterDocuments"
        >
          Letter Check Report
        </label>
        <div class="upload-image">
          <input
            id="letterDocuments"
            ref="uploadInputForLetters"
            type="file"
            class="file-uploader !h-10 p-0"
            @change="uploadLetters"
          >
          <div
            class="ml-4"
            :class="
              ` ${
                fileLoader
                  ? 'is-loading button primary'
                  : 'button primary'
              } `
            "
            @click="handleAddClickManualForLetters()"
          >
            Check
          </div>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
          for="siteLinkNotes"
        >
          Send SiteLink Notes
        </label>
        <div class="upload-image">
          <input
            id="siteLinkNotes"
            ref="uploadSiteLink"
            type="file"
            class="file-uploader"
            @change="uploadSiteLink"
          >
          <div
            class="ml-4"
            :class="{
              'is-loading button primary': isSiteLinkLoading,
              'button primary': !isSiteLinkLoading
            }"
            @click="sendSiteLinkFile()"
          >
            Send
          </div>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
          for="qaReport"
        >
          QA Report
        </label>
        <div class="upload-image">
          <input
            id="qaReport"
            ref="uploadInputForQA"
            type="file"
            class="file-uploader"
            @change="uploadImageForQA"
          >
          <div
            class="ml-4"
            :class="{
              'is-loading button primary': isSiteLinkLoading,
              'button primary': !isSiteLinkLoading
            }"
            @click="handleAddClickManualForQA()"
          >
            Check
          </div>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
          for="siteLinkNotes"
        >
          Tenants Report
        </label>
        <div class="upload-image">
          <input
            id="siteLinkNotes"
            ref="uploadTenantsIds"
            type="file"
            class="file-uploader"
            @change="uploadTenantsIds"
          >
          <div
            class="ml-4"
            :class="{
              'is-loading button primary': fileWithTenantsLoading,
              'button primary': !fileWithTenantsLoading
            }"
            @click="sendTenantsIdsFile()"
          >
            Send
          </div>
        </div>
      </div>

      <reports-audit-card />
    </div>

    <!-- <div class="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4 border-t border-b border-muted-300 dark:border-muted-600 py-4">
      <workorder-mail-card />
      <workorder-ucc-card />
      <workorder-hold-card />
      <workorder-audit-card />
      <workorder-public-notice />
      <workorder-auction-card />
    </div> -->
    <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4">
      <!-- <reports-email-card />
      <reports-letters-card />
      <reports-restart-card /> -->
      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
        >
          Email Report
        </label>
        <div class="flex items-center justify-between">
          <div class="email__input-wrapper">
            <label for="emailStartDate">Date from</label>
            <input
              id="emailStartDate"
              v-model="emailStartDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <div class="email__input-wrapper">
            <label for="emailEndDate">Date to</label>
            <input
              id="emailEndDate"
              v-model="emailEndDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <button
            class="button primary"
            @click="getEmailReport"
          >
            Get Report
          </button>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
        >
          Export Letters
        </label>
        <div class="flex items-center justify-between">
          <div class="email__input-wrapper">
            <label for="emailStartDate">Date from</label>
            <input
              id="emailStartDate"
              v-model="emailReportStartDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <div class="email__input-wrapper">
            <label for="emailEndDate">Date to</label>
            <input
              id="emailEndDate"
              v-model="emailReportEndDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <button
            class="button primary"
            @click="getReportLetters"
          >
            Get Letters
          </button>
        </div>
      </div>

      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
        >
          Restart reports
        </label>
        <div class="flex items-center justify-between h-20">
          <div class="email__input-wrapper">
            <label for="emailStartDate">Date from</label>
            <input
              id="emailStartDate"
              v-model="restartReportStartDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <div class="email__input-wrapper">
            <label for="emailEndDate">Date to</label>
            <input
              id="emailEndDate"
              v-model="restartReportEndDate"
              type="date"
              class="input is-outlined email-input"
            >
          </div>
          <button
            class="button primary"
            @click="getRestartReports"
          >
            Get Restart Reports
          </button>
        </div>
      </div>
      <div class="w-full card rounded p-3">
        <label
          class="block text-xl font-medium text-gray-900 dark:text-white"
        >
          Pending Release reports
        </label>
        <div class="flex items-center justify-between h-20">
          <button
            class="button primary"
            @click="getPendingReleaseReports"
          >
            Get Pending Release Reports
          </button>
        </div>
      </div>
    </div>

    <!-- Dialog -->
    <div
      class="modal"
      :class="{'is-active' : isShowExcelModal}"
    >
      <div
        class="modal-background"
        @click="hideExcelModal()"
      />
      <div class="modal-content">
        <div class="box">
          <div v-if="Object.keys(excelResponse.saved).length">
            <h6>Saved messages</h6>
            <div
              v-for="(key, idx) in Object.keys(excelResponse.saved)"
              :key="'failedItem' + idx"
            >
              <div>
                <p>
                  {{ key }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="Object.keys(excelResponse.errors).length">
            <h6>Error messages</h6>
            <div
              v-for="(key, idx) in Object.keys(excelResponse.errors)"
              :key="'failedItem' + idx"
            >
              <div>
                <span>{{ key }}.</span>
                <p>
                  {{ excelResponse.errors[key] }}
                </p>
              </div>
            </div>
          </div>

          <p
            class="control has-text-right"
            style="mt-4"
          >
            <button
              type="button"
              class="button is-white"
              @click="hideExcelModal()"
            >
              Close
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideExcelModal()"
      />
    </div>
  </div>
</template>

<script>
import { Roles } from '../../constants';
import { isExcel } from '../../utils/validationUtils';

export default {
  name: 'SystemReportsComponent',
  components: {
    // @todo use component :is
    // 'workorder-mail-card': () => import('./card/MailWorkorder'),
    // 'workorder-ucc-card': () => import('./card/UCCWorkorder'),
    // 'workorder-hold-card': () => import('./card/HoldWorkorder'),
    // 'workorder-audit-card': () => import('./card/AuditWorkorder.vue'),
    // 'workorder-public-notice': () => import('./card/PublicNoticeWorkorder'),
    // 'workorder-auction-card': () => import('./card/AuctionWorkorder'),
    // 'reports-email-card': () => import('./card/EmailReport'),
    // 'reports-letters-card': () => import('./card/ExportLetters'),
    // 'reports-restart-card': () => import('./card/RestartReports'),
    'reports-audit-card': () => import('./card/AuditReport')
  },
  data() {
    return {
      agentEmail: {
        isEmailTriggerOn: false,
        emailsInQueue: 0,
        isLoading: false
      },
      agentSms: {
        isSmsTriggerOn: false,
        smsInQueue: 0,
        isLoading: false
      },
      file: null,
      fileForQA: null,
      fileWithTenants: null,
      fileWithTenantsLoading: false,
      roles: Roles,
      fileLoader: false,
      fileLoaderForQA: false,
      isSiteLinkLoading: false,
      isShowExcelModal: false,
      role: this.$store.state.user.role,
      emailReportStartDate: '',
      emailStartDate: '',
      emailReportEndDate: '',
      restartReportStartDate: '',
      restartReportEndDate: '',
      emailEndDate: '',
      siteLinkFile: '',
      excelResponse: {
        saved: {},
        errors: {}
      }
    };
  },
  mounted() {
  },
  methods: {
    async getReportLetters() {
      if (!this.emailReportEndDate || !this.emailReportStartDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      try {
        const res = await this.$store.dispatch('getExcelFiles', {
          url: 'report/lien_list_usps',
          data: {
            start: this.emailReportStartDate,
            end: this.emailReportEndDate
          }
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.emailReportEndDate = '';
        this.emailReportStartDate = '';
      }
    },
    async getRestartReports() {
      if (!this.restartReportStartDate || !this.restartReportEndDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      try {
        const res = await this.$store.dispatch('getExcelFiles', {
          url: 'report/restarts',
          data: {
            start: this.restartReportStartDate,
            end: this.restartReportEndDate
          }
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.restartReportEndDate = '';
        this.restartReportStartDate = '';
      }
    },
    async getPendingReleaseReports() {
      try {
        const res = await this.$store.dispatch('getExcelFileByGetMethod', {
          url: 'report/pending_release'
        });
        const preparedUrl = window.URL.createObjectURL(res);
        window.open(preparedUrl, '_blank').focus();
        this.$root.$emit('showToast', {
          message: 'downloaded successfully',
          options: { cssClass: 'is-success', duration: 5000 }
        });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      }
    },
    getEmailReport() {
      if (!this.emailEndDate || !this.emailStartDate) {
        this.$root.$emit('showToast', {
          message: 'Please fill the dates',
          options: { cssClass: 'is-warning', duration: 5000 }
        });
        return;
      }
      const url = `${this.$store.state.API_URL}report/email_possible_reasons`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: JSON.stringify({
          start: this.emailStartDate,
          end: this.emailEndDate
        })
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.$root.$emit('showToast', {
            message: 'downloaded successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.emailEndDate = '';
          this.emailStartDate = '';
        })
        .catch((err) => {
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    uploadImage(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInput.value = '';
        this.file = '';
        return;
      }
      this.file = file;
    },
    uploadLetters(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInputForLetters.value = '';
        this.file = '';
        return;
      }
      this.file = file;
    },
    uploadSiteLink(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadSiteLink.value = '';
        this.siteLinkFile = '';
        return;
      }
      this.siteLinkFile = file;
    },
    uploadImageForQA(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadInputForQA.value = '';
        this.fileForQA = '';
        return;
      }
      this.fileForQA = file;
    },
    uploadTenantsIds(event) {
      const file = event.target.files[0];
      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', {
          message: 'Only excel files are allowed to be uploaded',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        this.$refs.uploadTenantsIds.value = '';
        this.fileWithTenants = '';
        return;
      }
      this.fileWithTenants = file;
    },
    handleAddClickManualForQA() {
      if (!this.fileForQA) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      this.fileLoaderForQA = true;
      const formData = new FormData();
      formData.append('file', this.fileForQA);
      const url = `${this.$store.state.API_URL}report/qa`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: formData
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.fileLoaderForQA = false;
          this.$root.$emit('showToast', {
            message: 'File checked successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.$refs.uploadInputForQA.value = '';
          this.fileForQA = '';
        })
        .catch((err) => {
          this.fileLoaderForQA = false;
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    handleAddClickManual() {
      if (!this.file) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      this.fileLoader = true;
      const formData = new FormData();
      formData.append('file', this.file);
      const url = `${this.$store.state.API_URL}docupload/check`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: formData
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: 'File checked successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.$refs.uploadInput.value = '';
          this.file = '';
        })
        .catch((err) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    handleAddClickManualForLetters() {
      if (!this.file) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      this.fileLoader = true;
      const formData = new FormData();
      formData.append('file', this.file);
      const url = `${this.$store.state.API_URL}docupload/check_v2`;
      const options = {
        headers: {
          Authorization: 'Bearer '.concat(this.$store.state.accessToken)
        },
        method: 'POST',
        body: formData
      };
      fetch(url, options)
        .then((response) => response.blob())
        .then((blob) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: 'File checked successfully',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          const preparedUrl = window.URL.createObjectURL(blob);
          window.open(preparedUrl, '_blank').focus();
          this.$refs.uploadInputForLetters.value = '';
          this.file = '';
        })
        .catch((err) => {
          this.fileLoader = false;
          this.$root.$emit('showToast', {
            message: err.response.data.message,
            options: { cssClass: 'is-danger', duration: 5000 }
          });
        });
    },
    async sendSiteLinkFile() {
      if (!this.siteLinkFile) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      try {
        this.isSiteLinkLoading = true;
        const formData = new FormData();
        formData.append('file', this.siteLinkFile);
        const res = await this.$store.dispatch('uploadExcelFile', {
          url: 'sitelink/insert_note',
          data: formData
        });
        this.openExcelModal();
        this.excelResponse = res.result;
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.response.data.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.isSiteLinkLoading = false;
      }
    },
    async sendTenantsIdsFile() {
      if (!this.fileWithTenants) {
        this.$root.$emit('showToast', {
          message: 'Please select a file',
          options: { cssClass: 'is-danger', duration: 5000 }
        });
        return;
      }
      try {
        this.fileWithTenantsLoading = true;
        const formData = new FormData();
        formData.append('file', this.fileWithTenants);

        const url = `${this.$store.state.API_URL}tenant/tenantIds`;
        const options = {
          headers: {
            Authorization: 'Bearer '.concat(this.$store.state.accessToken)
          },
          method: 'POST',
          body: formData
        };
        fetch(url, options)
          .then((response) => response.blob())
          .then((blob) => {
            this.$root.$emit('showToast', {
              message: 'File checked successfully',
              options: { cssClass: 'is-success', duration: 5000 }
            });
            const preparedUrl = window.URL.createObjectURL(blob);
            window.open(preparedUrl, '_blank').focus();
          })
          .catch((err) => {
            this.$root.$emit('showToast', {
              message: err.response.data.message,
              options: { cssClass: 'is-danger', duration: 5000 }
            });
          });
      } catch (err) {
        this.$root.$emit('showToast', {
          message: err.response.data.message,
          options: { cssClass: 'is-danger', duration: 5000 }
        });
      } finally {
        this.fileWithTenantsLoading = false;
        this.fileWithTenants = null;
        this.$refs.uploadTenantsIds.value = '';
      }
    },
    openExcelModal() {
      this.isShowExcelModal = true;
    },
    hideExcelModal() {
      this.isShowExcelModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
// .file-uploader {
//   @apply h-10;
// }

.modal {
  .modal-content {
    overflow: visible;
    .box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .upload-image {
        margin-top: 15px;
        display: flex;
        align-items: center;

        .image-preview {
          margin-left: 15px;
          width: 50px;
          height: 50px;
          border-radius: 5px;
          cursor: pointer;
          transition: transform 0.3s;
          z-index: 1;

          &:hover {
            transform: scale(2.5);
            border-radius: 0;
          }
        }
      }
    }
  }
}
</style>
